// extracted by mini-css-extract-plugin
module.exports = {"container":"homePage_container__2UGPK","title":"homePage_title__2soQJ","byPega":"homePage_byPega__2Dbw-"};